<template>
  <div>
    <el-row style="margin-top: 12px;align-items: flex-start;">
      <el-col :span="2" style="display: flex;">
        <img :src="require('@/assets/render/icons8_color_palette.svg')" style='width: 80%;'>
      </el-col>
      <el-col :span="10" class="propsLeft">{{ label }}</el-col>
      <el-col :span="12" class="propsRight">
        <el-switch v-model="innerVisible" @change="changeVisible"></el-switch>
      </el-col>
    </el-row>
    <el-row style="margin: 12px 0;align-items: flex-start;">
      <el-col :span="12" class="propsLeft"></el-col>
      <el-col :span="12" class="propsRight">
        <div style="display: flex;justify-content: end;align-items: flex-start;text-align: right;">
          <template v-if="$store.state.ui.os.isPC">
            <input type="color" class="color-trigger" v-model="innerColor" @input="changeColor" @click="loseFocus">
          </template>
          <template v-else>
            <el-color-picker color-format="hex" :show-alpha="false" v-model="innerColor" @active-change="changeColorActive"></el-color-picker>
          </template>
          <div style="margin-left: 10px;width: 60px;font-size: 14px;">{{ color.toUpperCase() }}</div>
        </div>
      </el-col>
    </el-row>
    <el-select v-if="blendMode" v-model="innerBlendMode" placeholder="Select" @change="changeBlendMode">
      <el-option
        v-for="item in SUPPORTED_BLEND_MODES"
        :key="item"
        :label="item"
        :value="item"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { rgbToHex } from '@/utils/Utils.js'
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#FFFFFF'
    },
    blendMode: {
      type: String
    }
  },
  data () {
    return {
      innerColor: '',
      innerVisible: false
    }
  },
  watch: {
    color (val) {
      this.innerColor = val
    },
    visible (val) {
      this.innerVisible = val
    }
  },
  mounted () {
    this.innerColor = this.color
    this.innerVisible = this.visible
  },
  methods: {
    changeBlendMode (val) {
      this.$emit('change', {
        id: this.id,
        valueProp: 'blendMode',
        value: val
      })
    },
    changeVisible () {
      this.$emit('change', {
        id: this.id,
        valueProp: 'visible',
        value: this.innerVisible
      })
    },
    changeColorActive (val) {
      const arr = val.replace('rgb(', '').replace(')', '').split(',')
      val = rgbToHex(Number.parseInt(arr[0]), Number.parseInt(arr[1]), Number.parseInt(arr[2]))
      this.$emit('change', {
        id: this.id,
        valueProp: 'color',
        value: val
      })
    },
    changeColor () {
      this.$emit('change', {
        id: this.id,
        valueProp: 'color',
        value: this.innerColor
      })
    },
    loseFocus () {
      this.$store.commit('loseFocus', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-trigger {
  width: 40px;
  height: 40px;
  border-color: lightgray;
}
</style>
